import React, { Component } from 'react';
import * as _ from 'lodash';
import { injectIntl, FormattedMessage, FormattedHTMLMessage } from 'react-intl';
import { observer } from 'mobx-react';
import { Api } from '../Api.js';
import navigationStructure from '../NavigationStructure.js';

import "../css/Survey.css";

class FeedbackForm extends Component {

    constructor() {
        super();
        this.handleSubmit = this.handleSubmit.bind(this);
    }

    componentWillUnmount() {
        let theform = document.getElementById("id_surveyform")
        this.submitDoit(theform, 0);
    }

    handleSubmit(event) {
        event.preventDefault();
        let theform = event.target;
        this.submitDoit(theform, 0);
    }

    fd_itoa(formdata) {
        var thearray = {};
        for(let prop of formdata) {thearray[prop[0]] = prop[1];}
        return thearray;
    }
    newFormData_removeItemIfEmpty(theform, name) {
        // text and textarea -- remove form item if empty to prevent overwriting survey item in DERBI
        let elem = document.getElementsByName(name)[0];
        let formData = new FormData(theform);
        if (elem && (elem.value === "")) {
            //do not remove the element itself
            //let e = elem.parentNode.removeChild(elem);
            formData = this.newFormData_withoutItem(theform, name);
        }
        return formData;
    }

    newFormData_withoutItem(theform, excludefieldname) {
        // because formData.remove() AND several other methods are  not well supported yet, make new with append() which is supported
        var inputs     = theform.getElementsByTagName('input');
        var inputsList = Array.prototype.slice.call(inputs);

        var newData    = new FormData();
        inputsList.forEach(
            function (i) {
                    let add = 1;
                    if (i.name === "") add = 0; // like a submit button without a name
                    if (i.name === excludefieldname) add = 0;
                    if ((i.type === "radio" || i.type === "checkbox") && !i.checked) add = 0;
                    if (add) newData.append(i.name, i.value);
            }
        );
        return newData;
    }

    submitDoit(theform, is_silent) {
        //alert("submitting..." + is_silent);

        let formData = this.newFormData_removeItemIfEmpty(theform, "survey[popup_q4]"); // don't submit && overwrite if the person does not type anything

        //test -- see if it's removing the right thing
        let a = this.fd_itoa(formData); //console.log(a);
        if (Object.keys(a).length === 0) return; //nothing to do

        let url = 'https://ikids-admin.reportback.org/report/survey?popup=1&id=cleaning';

        Api.postURL(url, formData).then((response) => {
            if (!is_silent) alert(this.props.thankyouText);
        }).catch(function(error) {
            console(error);
            if (!is_silent) alert(this.props.errorText);
        });
    }

    UNUSEDhandleChange(event) {
        this.setState({ value: event.target.value });
    }

    render() {
        return (
            <form id="id_surveyform" className="survey" onSubmit={this.handleSubmit}>
                <FormattedHTMLMessage id='page.survey.formcontent' />
            </form>
        );
    }
}

class SurveyPage extends Component {
  onClick(path) {
    //this.props.history.push(path);
    window.scrollTo(0, 0);
  }

  render() {
    const filterer = value => {
      const group_name = this.props.intl.messages[`chemicals.${value.group}.data`];
      if(this.props.appState.groups[group_name] !== undefined && this.props.appState.groups[group_name].length > 0) {
        return _.filter(this.props.appState.groups[group_name], { mine: true }).length > 0
      }
      else return false
    };

    const summary_items = Object.values(navigationStructure)
      .filter(value => value.summary)
      .filter(filterer)

    const water_summary_items = Object.values(navigationStructure)
      .filter(value => value.water_summary)
      .filter(filterer)

    return (
      <div className='survey page'>
        <h1>
          <FormattedMessage id='page.survey.title' />
        </h1>

        <FormattedHTMLMessage id='page.survey.content' />

        <FeedbackForm
            thankyouText={this.props.intl.messages['app.survey.thankyou']}
            errorText={this.props.intl.messages['app.survey.error']}
            sendButtonText={this.props.intl.messages['app.login.submit']}
        />

      </div>
    )
  }
}

export default observer(injectIntl(SurveyPage));



// WEBPACK FOOTER //
// ./src/pages/SurveyPage.js